import { render, staticRenderFns } from "./ruleNodeList.vue?vue&type=template&id=636ed9b8&scoped=true"
import script from "./ruleNodeList.vue?vue&type=script&lang=js"
export * from "./ruleNodeList.vue?vue&type=script&lang=js"
import style0 from "./ruleNodeList.vue?vue&type=style&index=0&id=636ed9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ed9b8",
  null
  
)

export default component.exports